import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbTimepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { CommerceService } from 'src/app/commerces/commerce.service';
import { MomentPipe } from 'src/app/moment-pipe.pipe';
import { AlertService } from 'src/app/services/alert-service.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FormChangeService } from 'src/app/services/form-change.service';
import { ParkingService } from 'src/app/services/parking.service';
import { CouponService } from '../coupon.service';

@Component({
  selector: 'app-create-coupon',
  templateUrl: './create-coupon.component.html',
  styleUrls: ['./create-coupon.component.scss']
})
export class CreateCouponComponent implements OnInit {
  couponCreateForm: FormGroup;
  addressObject ;
  constructor(
    private fb: FormBuilder,
    private digicodService: ParkingService,
    protected alertService: AlertService,
    private couponServ: CouponService,
    public authenSer: AuthenticationService,
    public activeModal: NgbActiveModal,
    private formService: FormChangeService,
    private route: Router,
    private momentPipe: MomentPipe,
    private config: NgbTimepickerConfig
  ) {
    config.seconds = false;
    config.spinners = false;
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.couponCreateForm = this.fb.group({
      expirationDate :new FormControl(""),
      note:new FormControl(""),
      TimeStart: new FormControl({hour: 0, minute: 0}, Validators.required),
    });

  }

  private createFromForm(): any {
    let tmp = {
      expirationDate:this.couponCreateForm.get(["expirationDate"]).value?this.couponCreateForm.get(["expirationDate"]).value:null,
      note: this.couponCreateForm.get(["note"]).value?this.couponCreateForm.get(["note"]).value:null,
    };
    let tmsl = this.couponCreateForm.controls.TimeStart;
    let hourStart =	tmsl!.value!.hour;
    let  minStart = tmsl!.value!.minute;
    tmp['timeParkFree'] = hourStart* 60 + minStart;
    tmp['merchantId'] = this.authenSer.getCurrentUser()['id'];

    return tmp;
  }

  getAddress(place: any) {
    this.addressObject = place;
  }
  save(): void {
    let commerceToSave = this.createFromForm();
    this.couponServ
      .saveCoupon(commerceToSave)
      .subscribe(
        (data) => {
          this.alertService.success("Coupon Sauvegardé !", true);
          this.formService.raiseReloadCouponsSearchRequestEvent();
          this.route.navigateByUrl("/coupons");
        },
        (error) => {
          console.log(error);
          this.alertService.error("Erreur dans le formulaire !", true);
        }
      );
  }

}
